// src/store/services/coach.js
import feathersClient, {
    makeServicePlugin,
    BaseModel
  } from "../../feathers-client";

  class Usercoach_Notes extends BaseModel {
    constructor (data, options) {
      super(data, options);
    }
    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = "Usercoach_Notes";
    // Define default properties here
    static instanceDefaults () {
      return {
        id: null,
        noteType: null,
        authorId: null,
        commuId: null,
        message: null,
        status: null,
        meetingDate: null,
        createdAt: null,
        updatedAt: null
      };
    }
  }
  const servicePath = "notes";
  const servicePlugin = makeServicePlugin({
    Model: Usercoach_Notes,
    service: feathersClient.service(servicePath),
    servicePath
  });

  // Setup the client-side Feathers hooks.
  feathersClient.service(servicePath).hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },
    after: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },
    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });

  export default servicePlugin;
